<script setup lang="ts">
import {
  summaryPanelClass,
  summaryPanelDetailsClass,
  summaryPanelHeaderClass,
  summaryPanelTabsClass,
  summaryPanelTitleClass,
} from './summaryPanelClasses'

import {
  BUDGET_ALLOCATION_TABS,
  DataVisible,
  ReportSectionTitle,
  SUMMARY_ACQUISITION_CHART,
} from '@/features/reports'
import { useI18n } from '@/shared/i18n'
import { Icon } from '@/shared/ui'

withDefaults(defineProps<{ defaultPostData?: string }>(), { defaultPostData: '' })
const { t } = useI18n()
</script>

<template>
  <section :class="summaryPanelClass">
    <header :class="[summaryPanelHeaderClass, 'p-xs']">
      <ReportSectionTitle
        :title="t('summary.acquisition.chartTitle')"
        :tabs="[...BUDGET_ALLOCATION_TABS]"
        :title-class="summaryPanelTitleClass"
        :tabs-class="summaryPanelTabsClass"
      />
      <RouterLink
        :class="[summaryPanelDetailsClass, 'summary-panel__details']"
        to="/budget-performance/budget-allocation"
      >
        <span>{{ t('summary.acquisition.details') }}</span>
        <Icon name="arrow-right" :size="14" />
      </RouterLink>
    </header>
    <DataVisible
      id="6-2-dasha"
      v-bind="{ ariaLabel: t('summary.acquisition.chartLabel') }"
      :report-id="SUMMARY_ACQUISITION_CHART.reportId"
      :default-post-data="defaultPostData"
      :dimensions="[...SUMMARY_ACQUISITION_CHART.dimensions]"
      :metrics="[...SUMMARY_ACQUISITION_CHART.metrics]"
      :partition-name="SUMMARY_ACQUISITION_CHART.partitionName"
      :sort-field="SUMMARY_ACQUISITION_CHART.sortField"
      view="chart"
      :allowed-views="['chart']"
      :allowed-chart-types="['pie', 'column']"
      :chart-type="SUMMARY_ACQUISITION_CHART.chartType"
      :empty-label="t('summary.states.empty')"
      :error-label="t('summary.states.error')"
      :retry-label="t('summary.actions.retry')"
    />
  </section>
</template>
